module.exports = __webpack_public_path__ + "img/bonus_button.2b63996b.png";